import React from 'react'
import { ProviderResponse } from '../../../../../types/FHIRTypes/ProviderResponse'
import { Endpoint } from '@teschglobal/tg-fhir-react-components/dist/types'
import useEnvironment from '../../../../../hooks/location/useEnviroment'
import FhirLoader from '../../../../FhirLoader'
import PaginationButtons from '../../../../PaginationButtons'
import { EndpointTable } from '@teschglobal/tg-fhir-react-components'

type EndpointListProps = {
    endpoints: ProviderResponse<Endpoint>;
    clickViewDataLink: (endpoint: Endpoint) => void;
    isFetching: boolean;
    isLoading: boolean;
    isSuccess: boolean;
    totalPages: number;
    currentPage: number;
    handleChangePage: (page: number) => void;
}

const EndpointList: React.FC<EndpointListProps> = ({ endpoints, clickViewDataLink, isFetching, isLoading, isSuccess, totalPages, currentPage, handleChangePage }) => {
    const { data: environment } = useEnvironment()
    const rows: Endpoint[] = endpoints?.data ?? []

    return (
        <div>
            <h3>Endpoint</h3>
            {
                isFetching || isLoading ? (
                    <FhirLoader message="Loading..." />
                ) : (
                    <>
                        {
                            endpoints?.total > 0 && environment?.includeTotalInFHIRRequest && (
                                <div className='my-3 fw-bold'>
                                    <span role="status" aria-live="polite">{endpoints?.total.toLocaleString()} record(s) found</span>
                                    <PaginationButtons
                                        totalPages={totalPages}
                                        currentPage={currentPage}
                                        handleChangePage={handleChangePage}
                                    />
                                </div>
                            )
                        }
                        <EndpointTable
                            endpoints={rows}
                            onRowLinkClick={clickViewDataLink}
                        />
                        {
                            endpoints?.total > 0 && environment?.includeTotalInFHIRRequest && (
                                <div className='my-3 fw-bold'>
                                    <span role="status" aria-live="polite">{endpoints?.total.toLocaleString()} record(s) found</span>
                                    <PaginationButtons
                                        totalPages={totalPages}
                                        currentPage={currentPage}
                                        handleChangePage={handleChangePage}
                                    />
                                </div>
                            )
                        }
                    </>
                )
            }
        </div>
    )
}

export default EndpointList